var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1692674335884,
    className: "icon",
    viewBox: "0 0 1111 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1910,
    width: 69.4375,
    height: 64,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 555.885714L555.885714 0l555.885715 555.885714h-146.285715v468.114286H146.285714V555.885714z",
    fill: "#7dc5eb",
    "p-id": 1911
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M409.6 1024V614.4h292.571429v409.6z",
    fill: "#333333",
    "p-id": 1912
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.3f3878b26351babe085e9b2211a1f990.svg";
export { ForwardRef as ReactComponent };